import {forOwn} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {connect} from 'react-redux';

import {
  areAllComponentsLoaded,
  getSearchServiceUrl,
} from 'src/js/containers/filter_and_search/filter_and_search_selectors';
import {
  initComponents,
  loadStateFromParams,
  setDynamicResultItems,
  setDefaultQueryParams,
} from 'src/js/containers/filter_and_search/filter_and_search_thunks';

class FilterAndSearchContainer extends React.Component {
  constructor(props) {
    super(props);
    const {
      defaultSearchServiceUrl,
      defaultQueryParams,
      dynamicResultItems,
      filterAndSearchStateId,
      searchComponents,
      searchServiceUrl,
      featureName,
    } = this.props;
    this.props.setDynamicResultItems(
      filterAndSearchStateId,
      dynamicResultItems
    );
    this.props.initComponents(
      filterAndSearchStateId,
      searchComponents,
      defaultSearchServiceUrl || searchServiceUrl
    );
    if (defaultQueryParams) {
      this.props.setDefaultQueryParams(
        filterAndSearchStateId,
        defaultQueryParams,
        featureName
      );
    }
  }

  componentDidMount() {
    const {
      defaultQueryParams,
      filterAndSearchStateId,
      queryParameters,
      featureName,
    } = this.props;
    // set default query parameters if current params are different
    if (defaultQueryParams && queryParameters) {
      // eslint-disable-next-line consistent-return
      forOwn(defaultQueryParams, (value, key) => {
        if (queryParameters[key] !== value) {
          this.props.setDefaultQueryParams(
            filterAndSearchStateId,
            defaultQueryParams,
            featureName
          );
          return false;
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      allComponentsLoaded,
      defaultSearchServiceUrl,
      filterAndSearchStateId,
      locationState,
      searchServiceUrl,
      featureName,
    } = this.props;
    if (
      (allComponentsLoaded &&
        prevProps.allComponentsLoaded !== allComponentsLoaded) ||
      // TODO: search after reload
      (locationState.reload &&
        prevProps.locationState.reload !== locationState.reload)
    ) {
      this.props.loadStateFromParams(
        filterAndSearchStateId,
        defaultSearchServiceUrl || searchServiceUrl,
        featureName
      );
    }
  }

  render() {
    return null;
  }
}

FilterAndSearchContainer.displayName = 'FilterAndSearchContainer';

/* eslint-disable react/no-unused-prop-types */
FilterAndSearchContainer.propTypes = {
  defaultQueryParams: PropTypes.objectOf(PropTypes.any),
  dynamicResultItems: PropTypes.objectOf(PropTypes.any),
  filterAndSearchStateId: PropTypes.string.isRequired,
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  searchComponents: PropTypes.objectOf(PropTypes.any),
  searchServiceUrl: PropTypes.string.isRequired,
  defaultSearchServiceUrl: PropTypes.string,
  featureName: PropTypes.string,
};

FilterAndSearchContainer.defaultProps = {
  defaultQueryParams: undefined,
  defaultSearchServiceUrl: undefined,
  dynamicResultItems: {},
  searchComponents: {},
};

export default connect(
  (state, props) => ({
    ...state[props.filterAndSearchStateId],
    allComponentsLoaded: areAllComponentsLoaded(state, props),
    searchServiceUrl: getSearchServiceUrl(state, props),
  }),
  {
    loadStateFromParams,
    initComponents,
    setDynamicResultItems,
    setDefaultQueryParams,
  }
)(FilterAndSearchContainer);
